import { createFileRoute } from '@tanstack/react-router';

import { OutboundQuietHoursSettings } from '@apps/web/components/settings/outbound_quiet_hours_settings';
import {
    renderPhoneSetupRouteGuard,
    usePhoneSetupRoute,
} from '@apps/web/components/settings/phone_setup/use_phone_setup_route';
import { SettingsPageShell } from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/quiet-hours')({
    component: QuietHoursSettingsPage,
});

function QuietHoursSettingsPage() {
    const routeState = usePhoneSetupRoute();

    return renderPhoneSetupRouteGuard(routeState, (ready) => (
        <SettingsPageShell
            title="Quiet hours"
            description="During quiet hours Phoebe won’t place follow-up calls; anything held goes out when the window ends. The first attempt of an outreach always goes out. Set a schedule for caregivers and clients below."
        >
            <OutboundQuietHoursSettings
                organizationId={ready.organizationId}
                organization={ready.organization}
                canManage={ready.canManageOrgTelephony}
                mutateOrganization={ready.mutateOrganization}
            />
        </SettingsPageShell>
    ));
}
